// Komponenty společné pro layout (mobilní menu v headeru apod.)
import '../components/header.js';
import '../components/homepage-video.js';
import '../components/forms.js';
import '../components/content-gallery.js';

/**
 * Lightbox pro zvětšení obrázků v článku (GLightbox – globál z vendor bundle).
 * Obrázky galerie sdílejí data-gallery="blog", takže šipky listují mezi nimi.
 */
function initLightbox() {
    if (typeof GLightbox === 'undefined') return;
    GLightbox({
        selector: '.blog-image',
        loop: true,
        touchNavigation: true,
    });
}

document.addEventListener('DOMContentLoaded', initLightbox);
